import { render, staticRenderFns } from "./SectionField.vue?vue&type=template&id=32879c32"
import script from "./SectionField.vue?vue&type=script&lang=js"
export * from "./SectionField.vue?vue&type=script&lang=js"
import style0 from "./SectionField.vue?vue&type=style&index=0&id=32879c32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports